@if (loading) {
  <div class="tt-drag-and-drop_spinner">
    <tt-spinner />
  </div>
}
<div class="tt-drag-and-drop_zone">
  <div class="tt-drag-and-drop_zone-title">
    {{ ('Available' | transloco) + ' ' + (title | transloco) }}
  </div>
  <div class="tt-drag-and-drop_zone-search">
    <input placeholder="{{ 'Search' | transloco }}" ttInput [formControl]="searchTerm" />
  </div>
  <div class="tt-drag-and-drop_zone-label">
    <span>{{ 'Name' | transloco }}</span>
    <span>{{ 'UpdatedAt' | transloco }}</span>
  </div>
  <div class="tt-drag-and-drop_zone-list">
    <div
      #availableResourceList="cdkDropList"
      cdkDropList
      class="tt-drag-and-drop_zone-list-item"
      id="availableResourceList"
      [cdkDropListConnectedTo]="[attachedResourceList]"
      [cdkDropListData]="filteredAvailableResources()"
      (cdkDropListDropped)="drop($event)"
      (cdkDropListEntered)="entered($event)"
      (cdkDropListExited)="exited($event)">
      @for (item of filteredAvailableResources(); track item.ID) {
        <div
          cdkDrag
          class="tt-drag-and-drop_zone-list-item-drag"
          [cdkDragData]="item"
          (cdkDragEnded)="onDragEnd()"
          (cdkDragStarted)="onDragStart()">
          <div class="tt-drag-and-drop_zone-list-item-drag-element">
            <mat-icon class="svg-icon" [icon]="item.icon" [iconSize]="20" />
            @if (dialogType === dialogTypes.Attachment) {
              <div class="tt-drag-and-drop_zone-list-item-drag-element-title">
                <span>{{ item.Normal[0] }}</span>
              </div>
            }
            @if (dialogType === dialogTypes.Literature) {
              <div class="tt-drag-and-drop_zone-list-item-drag-element-title">
                <span>
                  {{ item.Strong }}
                </span>
              </div>
            }
            <div class="tt-drag-and-drop_zone-list-item-drag-element-data">
              <span>{{ item?.updateDate | utcToLocal }}</span>

              <button aria-label="Add attachment" (click)="addAttachedResource(item)">
                <mat-icon [attr.data-testid]="testidDialogType + '_add-resource-button-' + item.ID" [icon]="'plus'" [iconSize]="20" />
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
<div class="tt-drag-and-drop_zone">
  <div class="tt-drag-and-drop_zone-title">
    {{ isUploadInProgress ? ('FilesHub' | transloco) : ('Attached' | transloco) + ' ' + (title | transloco) }}

    <div class="tt-drag-and-drop_upload">
      @if (!isUploadInProgress) {
        <mat-icon [icon]="'upload'" [iconSize]="20" [ttTooltip]="'Upload' | transloco" (click)="onUploadStarted()" />
      }
      @if (isUploadInProgress) {
        <mat-icon
          [icon]="'file-search'"
          [iconSize]="20"
          [ttTooltip]="'GuidelineManagePage.BackToSearch' | transloco"
          (click)="onUploadCancel()" />
      }
    </div>
  </div>

  <div #attachedResourceContainer>
    <div class="tt-drag-and-drop_zone-search">
      <input placeholder="{{ 'Search' | transloco }}" ttInput [(ngModel)]="attachedSearchTerm" (input)="onSearchAttached($event)" />
    </div>

    <div class="tt-drag-and-drop_zone-label">
      <span>{{ 'Name' | transloco }}</span>
      <span>{{ 'UpdatedAt' | transloco }}</span>
    </div>

    <div class="tt-drag-and-drop_zone-list">
      <div
        #attachedResourceList="cdkDropList"
        cdkDropList
        class="tt-drag-and-drop_zone-list-item guideline-dropzone"
        id="attachedResourceList"
        [cdkDropListConnectedTo]="[availableResourceList]"
        [cdkDropListData]="filteredAttachedResources()"
        (cdkDropListDropped)="drop($event)"
        (cdkDropListEntered)="entered($event)"
        (cdkDropListExited)="exited($event)">
        <div class="tt-drag-and-drop_zone-list-item-overlay hidden" id="overlay">
          <div class="tt-drag-and-drop_zone-list-item-overlay-content">{{ 'DropFilesHere' | transloco }}</div>
        </div>

        @if (!attachedSearchTerm) {
          @for (item of filteredAttachedResources(); track item.ID) {
            <div cdkDrag class="tt-drag-and-drop_zone-list-item-drag" [cdkDragData]="item">
              <div class="tt-drag-and-drop_zone-list-item-drag-element">
                <mat-icon class="svg-icon" [icon]="item.icon" [iconSize]="20" />
                @if (dialogType === dialogTypes.Attachment) {
                  <div class="tt-drag-and-drop_zone-list-item-drag-element-title">
                    <span>{{ item.Normal[0] }}</span>
                  </div>
                }
                @if (dialogType === dialogTypes.Literature) {
                  <div class="tt-drag-and-drop_zone-list-item-drag-element-title">
                    <span>
                      {{ item.Strong }}
                    </span>
                  </div>
                }
                @if (item.imported) {
                  <mat-icon
                    class="item_imported-icon"
                    [icon]="'import'"
                    [iconSize]="16"
                    [ttTooltip]="'GuidelineManagePage.Imported' | transloco" />
                }
                <div class="tt-drag-and-drop_zone-list-item-drag-element-data">
                  <span>{{ item?.updateDate | utcToLocal }}</span>
                  @if (item.imported) {
                    <button (click)="removeImportedResource(item)"><mat-icon [icon]="'x'" [iconSize]="20" /></button>
                  } @else {
                    <button (click)="removeAttachedResource(item)"><mat-icon [icon]="'x'" [iconSize]="20" /></button>
                  }
                </div>
              </div>
            </div>
          }
        }

        @if (attachedSearchTerm) {
          @for (item of searchedAvailableResources; track item.ID) {
            <div cdkDrag class="tt-drag-and-drop_zone-list-item-drag">
              <div class="tt-drag-and-drop_zone-list-item-drag-element">
                <mat-icon class="svg-icon" [icon]="item.icon" [iconSize]="20" />
                @if (dialogType === dialogTypes.Attachment) {
                  <div class="tt-drag-and-drop_zone-list-item-drag-element-title">
                    <span>{{ item.Normal[0] }}</span>
                  </div>
                }

                @if (dialogType === dialogTypes.Literature) {
                  <div class="tt-drag-and-drop_zone-list-item-drag-element-title">
                    <span>
                      {{ item.Strong }}
                    </span>
                  </div>
                }
                <div class="tt-drag-and-drop_zone-list-item-drag-element-data">
                  <span>{{ item?.updateDate | utcToLocal }}</span>
                  <button (click)="removeAttachedResource(item)"><mat-icon [icon]="'x'" [iconSize]="20" /></button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
  @if (isUploadInProgress) {
    <div class="upload-container">
      @if (dialogType === dialogTypes.Attachment) {
        <add-attachment (assetChange)="addAttachment($event)" (assetNameChanged)="handleAssetNameChanged($event)" />
      }
      @if (dialogType === dialogTypes.Literature) {
        <ng-container>
          <add-literature (fileAdded)="addLiterature($event)" />
        </ng-container>
      }
      <button class="upload-container__button" ttButton [disabled]="disableUploadButton" [isBusy]="uploading" (click)="onUploadClicked()">
        {{ 'Upload' | transloco }}
      </button>
    </div>
  }
</div>
